import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { tiposCampos } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye } from "react-icons/fa";

class FormasPagamentoEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.state = {
            nome: '',
            status: true,
            erroLoadRegistro: "",
            forma_pagamento_id: "",
            titulo_pagina: "",
            loading: false,
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                forma_pagamento_id: id,
                titulo_pagina: 'Editando Forma de Pagamento',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/formas-pagamento/${id}/`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    status: dados.status,
                    loading: false
                });

            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar forma de pagamento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                forma_pagamento_id: '',
                titulo_pagina: 'Adicionar Forma de Pagamento',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            statusHelper: "",
        });

        //vererifica se é edição ou adição
        const url = (this.state.forma_pagamento_id) ? '/formas-pagamento/'+this.state.forma_pagamento_id+'/' : '/formas-pagamento/'
        const metodo = (this.state.forma_pagamento_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);
        formData.append('status', this.state.status);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.forma_pagamento_id) ? 'Forma de Pagamento atualizada com sucesso' : 'Forma de Pagamento cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.produto_id){
                this.props.router.navigate("/formaspagamento");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar forma de pagamento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'status'){
                        this.setState({ statusHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "status") {
            this.setState({ [name]: value === "true" });
        } else {
            this.setState({ [name]: value });
        }
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados das Formas de Pagamento</h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome</Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome da Forma de Pagamento" value={this.state.nome} onChange={this.handleChange} />
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Status</Form.Label>
                                                <Form.Select className="form-control" name="status" value={this.state.status.toString()} onChange={this.handleChange}>
                                                    <option value="true">Ativo</option>
                                                    <option value="false">Inativo</option>
                                                </Form.Select>
                                                <Form.Text id="formStatusHelpBlock" className="text-danger">
                                                    {this.state.statusHelper}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                               
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
            </div>
        )
    }
}

export default withRouter(FormasPagamentoEdit);